export default __webpack_public_path__ + "static/media/wedi-logo.7e02f427.png";